/**
 * Keeps page-position restoration for browser history while treating direct
 * navigation as a new destination journey.
 */
export function getNavigationScrollPosition(historyAction: string, savedScroll: number): number {
    return historyAction === 'POP' ? savedScroll : 0
}